import React, { PureComponent } from "react";
import { injectIntl, defineMessages } from "react-intl";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';

import * as templateActions from 'modules/template';
import { timeDiffFromSeconds } from "libs/commonFunc";
import { ModalTemplate, Loading, Button as Btn, VideoPlayer, ReduxFormSemanticDropdown } from "components";
import "./EduTemplateVideo.css";

class EduTemplateVideo extends PureComponent {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { dataInfo, toggleModal, formStore } = this.props;
    const videoData = dataInfo.eduTagData;

    // 선택한 동영상 index
    let currentIndex = 0;
    if (formStore && formStore.values && formStore.values.fileNo) {
      currentIndex = videoData.findIndex((eduItem) => {
        return eduItem.fileNo === formStore.values.fileNo;
      });
    }

    // 동영상 src 리스트
    const sourceList = [];
    videoData.map((eduItem) => {
      sourceList.push({
        src: eduItem.filePath,
        type: "video/mp4",
      });
    });

    // 동영상 플레이어 옵션
    const videoPlayerOptions = {
      autoPlay: false,
      playbackRates: [1, 1.25, 1.5, 2],
      controls: true,
      sources: sourceList,
      controlBar: {
        pictureInPictureToggle: false,
      },
    };

    // 동영상 드롭다운 리스트
    const videoSelectList = [];
    videoData.map((eduItem) => {
      videoSelectList.push({
        key: eduItem.fileNo,
        value: eduItem.fileNo,
        text: eduItem.fileName,
      });
    });

    // 총 영상 시간
    let totalTime = 0;
    videoData.map((eduItem) => (totalTime += eduItem.runnungTime));

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={"modal-admin modal-eduTemplate common-content"}
        closeIcon
        onToggleModal={toggleModal}
        visible
        header={<div>{defineMessages(formatMessage({ id: "EduTemplate_3", defaultMessage: "영상 보기" }))}</div>}
        buttons={
          <div className={"inline-block"}>
            <Btn buttonColor="#bbbbbb" onClick={toggleModal}>
              {defineMessages(formatMessage({ id: "ExamTemplateCopy_2", defaultMessage: "취 소" }))}
            </Btn>
            {/* <Btn className={"brand-button"} loading={loading} disabled={loading} onClick={copyTemplate}>
              {defineMessages(formatMessage({ id: "ExamTemplateCopy_11", defaultMessage: "복 제" }))}
            </Btn> */}
          </div>
        }
      >
        <span className="materialTextField-title">{defineMessages(formatMessage({ id: "EduTemplate_5", defaultMessage: "영상 목록" }))}</span>
        <div>
          <ReduxFormSemanticDropdown
            name="fileNo"
            className={"dropdown-list"}
            fluid
            search
            selection
            selectOnBlur={false}
            options={videoSelectList}
            checkType={100}
            defaultValue={videoData[0].fileNo}
          />
        </div>

        <span className="materialTextField-title">{defineMessages(formatMessage({ id: "EduTemplate_6", defaultMessage: "영상 미리보기" }))}</span>
        <div className="video-box">
          <div className="video-header">
            <div className="video-title">
              <div>{dataInfo.attachName}</div>
              <div>
                {defineMessages(formatMessage({ id: "EduTemplate_7", defaultMessage: "총 영상 시간" })) + ": "}
                {timeDiffFromSeconds(totalTime)}
              </div>
            </div>
            <div className="video-title sub">
              <div>{videoData[currentIndex].fileName}</div>
              <div>
                {defineMessages(formatMessage({ id: "EduTemplate_8", defaultMessage: "영상 시간" })) + ": "}
                {timeDiffFromSeconds(videoData[currentIndex].runnungTime)}
              </div>
            </div>
          </div>
          <VideoPlayer {...videoPlayerOptions} currentIndex={currentIndex} />
        </div>
      </ModalTemplate>
    );
  }
}

const mapStateToProps = (state, props) => ({    
  initialValues: props.dataInfo,
  formStore: state.form['formEduTemplateVideo'],
});

const mapDispatchToProps = dispatch => ({
  TemplateActions: bindActionCreators(templateActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
      form: 'formEduTemplateVideo',
      enableReinitialize: true,
      touchOnChange: true
  })(injectIntl(EduTemplateVideo))
);


// WEBPACK FOOTER //
// ./src/script/components/eduTemplate/EduTemplateVideo.js